import ApiRouteProvider from '../route'
import axios from '@axios'

export default {
    importCandidateList(listId, file, calculateChangeSet, validFrom) {
        const form = new FormData();
        form.append('file', file);
        form.append('list', listId);
        form.append('validFrom', validFrom);
        form.append('calculateChangeSet', calculateChangeSet ? 1 : 0)
        return axios.post(ApiRouteProvider.import.candidateList(), form);
    },
    importSuppliers(validate, file) {
        const form = new FormData();
        form.append('control', validate ? 1 : 0)
        form.append('file', file);
        return axios.post(ApiRouteProvider.getBaseUrl() + '/import/suppliers', form);
    }
};
